import {Injectable} from '@angular/core';
import {HttpBaseService} from "@tva/ng-migration/core";
import {HttpClient} from "@angular/common/http";
import {schoolwork12} from "@tva/ng-migration/common/util";

@Injectable({
  providedIn: 'root'
})
export class CourseManagementService extends HttpBaseService {

  constructor(client: HttpClient) {
    super(client);
  }

  getCourseManagementSearchFilters(){
    return this.get(schoolwork12.app.manageCourseManagement.endpoints.courseFilter);
  }

  getCourseDropDownDetails(){
    return this.get(schoolwork12.app.manageCourseManagement.endpoints.courseDropDownDetails);
  }

  getCourseByCode (courseCode: string){
    return this.get(schoolwork12.app.manageCourseManagement.endpoints.courseByCode + courseCode);
  }

  nextCourseListByCode (courseCode: string){
    return this.get(schoolwork12.app.manageCourseManagement.endpoints.nextCourseListByCode + courseCode);
  }

  addCourse (course: object){
    return this.post(schoolwork12.app.manageCourseManagement.endpoints.addCourse, course);
  }

  editCourse (course: object){
    return this.put(schoolwork12.app.manageCourseManagement.endpoints.addCourse, course);
  }

  searchCourses (filters: object){
    return this.post(schoolwork12.app.manageCourseManagement.endpoints.searchCourses, filters);
  }

  reactivateCourses (courses: object[]){
    return this.put(schoolwork12.app.manageCourseManagement.endpoints.reactivateCourses, courses);
  }

  deactivateCourses (courses: object[]){
    return this.put(schoolwork12.app.manageCourseManagement.endpoints.deactivateCourses, courses);
  }
}
